import { Fragment } from "react/jsx-runtime";
import ModalPageFooter from "../../../global-layout/modal-page-footer";
import PreviewCreatedLabel from "../../preview-created-label";
import StepsHeader from "../../steps-header";
import UploadTrainingDataSet from "../../upload-training-dataset";
import KeywordCreationChip from "../../../UI/keyword-creation-chip";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { magicServices } from "../../../../services/InspectionOneServices";

function CustomMagicStepFour({
  setCurrentStep,
  title,
  data,
  setData,
  handleSubmit,
  isLoading,
}: any) {
  const { id, magicType } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [dynamicHeight, setDynamicHeight] = useState(0);
  const elementRef = useRef<any>(null);

  useEffect(() => {
    if (elementRef.current) {
      const height = elementRef.current.clientHeight - 20;

      setDynamicHeight(height);
    }
  }, [title]);

  const [activeTabUniqueId, setActiveTabUniqueId] = useState(() => {
    // Find the first label where isDeleted is 0
    const validLabel = data.labels.find((label: any) => label.isDeleted === 0);
    return validLabel ? validLabel.uniqueId : null;
  });

  useEffect(() => {
    if (data.labels.length > 0) {
      // Find the first label where isDeleted is 0
      const validLabel = data.labels.find(
        (label: any) => label.isDeleted === 0
      );
      if (validLabel) {
        setActiveTabUniqueId(validLabel.uniqueId);
      }
    }
  }, [data.labels]);
  // Handle label click
  const handleLabelClick = (uniqueId: any) => {
    setActiveTabUniqueId(uniqueId);
  };

  const [selectedSidebar, setSelectedSidebar] = useState<any>(null);
  const [galleryImage, setgalleryImage] = useState<any[]>([]);
  const [iterationsData, setIterationsData] = useState<any[]>([]);
  const [iteration, setIteration] = useState<any>(0);
  const [screenLoadedCount, setScreenLoadedCount] = useState<any>(0);
  const [sasToken, setSasToken] = useState("");
  const handleGetLabelDetailFetch = async (iteration: number) => {

    // setIterationsData([]);
    setgalleryImage([]);
    try {
      const requestData = {
        uniqueId: data.uniqueId,
        iteration,
        pageCount: 20,
        pageNumber: 1,
      };
      const response = await magicServices.MagicLabelDetailfetch(requestData);
      if (response.success) {
        const labels = response.data?.labels || [];
        setSasToken(response.data.sasToken);
        setIterationsData(response.data?.iterationsList);
        const galleryImages = labels
          .filter((label: { magicUrl: any }) => label.magicUrl)
          .map(
            (label: {
              magicUrl: any;
              width: any;
              height: any;
              uniqueId: any;
            }) => ({
              url: label.magicUrl,
              width: label.width || 0,
              height: label.height || 0,
              uniqueId: label.uniqueId,
            })
          );

        setgalleryImage(galleryImages);
        setScreenLoadedCount(galleryImages.length);
        console.log("response from MagicLabelDetailfetch", response);
      }
    } catch (error) {
      console.error("Error fetching labels", error);
    }
  };


  const getIterationValue = (sidebar: any) => {
    if (sidebar == null) return 0;
    else return sidebar.iteration;
  };


  useEffect(() => {
    if (Number(magicType) == 2) {

      const iteration = getIterationValue(selectedSidebar);
      setIteration(iteration)
      handleGetLabelDetailFetch(iteration);
    }
  }, [selectedSidebar]);

  return (
    <div className="w-full h-full flex flex-col">
      <StepsHeader title={title} />
      <div className="w-full h-auto my-3">
        <div className="w-full h-auto flex justify-start items-center my-3">
          <p className="w-[10%] max-md:w-[15%] text-[1.6rem] font-inter font-normal text-io-gray-66 dark:text-io-white dark:text-opacity-50">
            {t("web.magix.label.magicname")}
          </p>
          <p className="w-[90%] max-md:w-[85%] text-[1.6rem] font-inter font-normal text-io-black dark:text-io-white">
            {data.name}
          </p>
        </div>
        <div className="w-full h-auto flex justify-start items-center my-3">
          <p className="w-[10%] max-md:w-[15%] text-[1.6rem] font-inter font-normal text-io-gray-66 dark:text-io-white dark:text-opacity-50">
            {t("web.magix.label.description")}
          </p>
          <p className="w-[90%] max-md:w-[85%] text-[1.6rem] font-inter font-normal text-io-black dark:text-io-white">
            {data.description}
          </p>
        </div>
      </div>
      {
        Number(magicType) != 2 &&
        <div
          className="w-full flex-auto basis-0 overflow-y-auto scrollbar-large"
          ref={elementRef}
        >
          <div className="w-full relative">
            <div className="w-full h-full p-4">
              <div className="w-full h-full flex">
                <div className="w-[21.26%] h-full sticky top-4 max-md:w-[35%]">
                  <div
                    className="w-full bg-io-gray-f8 dark:bg-io-black-1c pt-3 flex flex-col"
                    style={{ height: dynamicHeight }}
                  >
                    <div className="w-full flex-auto basis-0 pl-2 overflow-y-auto">
                      {data.labels.map((label: any, i: any) => {
                        if (label.isDeleted === 0) {
                          return (
                            <Fragment key={i}>
                              <KeywordCreationChip
                                labelName={label.name}
                                isActive={activeTabUniqueId === label.uniqueId}
                                isCheckbox={false}
                                currentStatus={false}
                                hasDeleteOption={false}
                                onClick={() => handleLabelClick(label.uniqueId)}
                              />
                            </Fragment>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
                <div className="w-[78.74%] h-auto ml-auto max-md:w-[65%]">
                  <div className="w-full h-auto px-[4.5rem] py-[3.5rem] max-md:p-[3rem]">
                    <PreviewCreatedLabel
                      isEditable={false}
                      fullScreenOption={false}
                      currentLabel={data.labels.find(
                        (label: any) =>
                          label.isDeleted === 0 &&
                          label.uniqueId === activeTabUniqueId
                      )}
                      activeTabUniqueId={activeTabUniqueId}
                    />
                    {Number(magicType) === 3 ? (
                      <UploadTrainingDataSet
                        isViewOnly={true}
                        data={data}
                        setData={setData}
                        activeTabUniqueId={activeTabUniqueId}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {
        Number(magicType) == 2 &&
        <div className={`w-full h-full flex ${screenLoadedCount > 4 ? "max-h-[45%]" : ""}`}>
          {/* Sidebar */}
          <div className="w-[20%] h-full bg-io-gray-f8">
            <ul className="space-y-2 flex flex-col">
              <li
                key={0}
                onClick={() => setSelectedSidebar(null)}
                className={`py-[1rem] pl-[1rem] rounded-md cursor-pointer text-[1.5rem] 
                  ${selectedSidebar == null
                    ? "bg-gray-400 text-io-black"
                    : "hover:bg-gray-200 text-io-black"
                  }
                `}
              >
                {"Untagged"}
              </li>
              {iterationsData.map((item: any, idx: any) => (
                <li
                  key={idx}
                  onClick={() => setSelectedSidebar(item)}
                  className={`py-[1rem] pl-[1rem] rounded-md cursor-pointer text-[1.5rem] 
                  ${selectedSidebar && selectedSidebar.iteration === item.iteration
                      ? "bg-gray-400 text-io-black"
                      : "hover:bg-gray-200 text-io-black"
                    }
                `}
                >
                  {`Iteration ${item.iteration}`}
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side - Scrollable Gallery */}
          <div className="flex-1 p-4 overflow-y-auto">

            {galleryImage.length > 0 ? (
              <div className="grid grid-cols-4 gap-4">
                {galleryImage.map((img: any, idx) => (
                  <div
                    key={idx}
                    className="relative w-full h-40 border rounded-lg overflow-hidden shadow hover:scale-105 transition-transform"
                  >
                    <img
                      src={img.url + sasToken}
                      alt={`gallery-${idx}`}
                      className="w-full h-full object-cover"
                    />

                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center text-gray-500 py-10 text-lg">
                No images found
              </div>
            )}
          </div>
        </div>
      }

      <ModalPageFooter
        footerType="steps"
        goToPrevious={() => setCurrentStep(Number(magicType) === 3 ? 3 : 2)}
        goToNext={() => navigate("/ai-magic-studio/vision")}
        isFinalStep={true}
        handleSaveDraft={handleSubmit}
        setData={setData}
        data={data}
        isLoading={isLoading}
      />
    </div>
  );
}
export default CustomMagicStepFour;
